var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.96824 1.96824C0 3.93648 0 7.1043 0 13.44V14.56C0 20.8957 0 24.0635 1.96824 26.0318C3.93648 28 7.1043 28 13.44 28H14.56C20.8957 28 24.0635 28 26.0318 26.0318C28 24.0635 28 20.8957 28 14.56V13.44C28 7.1043 28 3.93648 26.0318 1.96824C24.0635 0 20.8957 0 14.56 0H13.44C7.1043 0 3.93648 0 1.96824 1.96824ZM4.72507 8.51672C4.87674 15.7967 8.51672 20.1717 14.8984 20.1717H15.2601V16.0067C17.6051 16.2401 19.3783 17.9551 20.09 20.1717H23.4034C22.4934 16.8584 20.1016 15.0267 18.6083 14.3267C20.1016 13.4634 22.2016 11.3634 22.7033 8.51672H19.6932C19.0399 10.8267 17.1034 12.9267 15.2601 13.1251V8.51672H12.25V16.5901C10.3833 16.1234 8.02672 13.8601 7.92172 8.51672H4.72507Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsVk);
export default __webpack_public_path__ + "static/media/icons_VK.91648b8949bb3d2742dfc17f80f2bc9d.svg";
export { ForwardRef as ReactComponent };